export const Mode = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  DETAIL: "DETAIL",
};
